<template>
    <div class="Hardware">
        <div class="pageContent">
            <TopLogoBar logoColor="black" logoSpecial="hardware" textColor="#000" title="HARDWARE" />
            <div class="container infoContainer">
                <div class="columns">
                    <div class="column is-6">
                        <p class="descriptionText">
                            page93® offre una vasta gamma di marchi hardware
                            offrendovi la garanzia di acquistare un prodotto di alta
                            qualità.<br><br>
                            La gamma completa di articoli spazia dal singolo componente
                            hardware a tutte le periferiche, nonché i relativi accessori e
                            consumabili.<br><br>
                            
                            Computer<br>
                            Server<br>
                            Fotocopiatrici<br>
                            Multifunzione<br>
                            Stampanti<br>
                            Notebook<br>
                            Scanner<br>
                            Lettori Barcode
                        </p>
                    </div>
                    <div class="column is-6 imageContainer">
                        <img src="@/assets/images/hardwareImage3.jpg" />
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
    import Footer from '@/components/Footer'
    import TopLogoBar from '@/components/TopLogoBar'
    export default {
        name: 'Hardware',
        props: [],
        components: {
            TopLogoBar,
            Footer
        },
    }
</script>

<style scoped lang="scss">
    .Hardware {
        width: 100%;

        .pageContent {
            width: 100%;
            position: relative;
            color: #000;

            .infoContainer {
               // display: flex;
                // height: 100%;
                padding: 20px;
            }

            .descriptionText {
                font-size: 1.1rem;
                font-weight: 900;
                text-align: left;
                text-align: justify;

                @media only screen and (min-width: 768px) {
                    margin-right: 100px;
                    margin-left: 100px;
                    margin-top: 60px;
                }
            }

            .imageContainer {
                @media only screen and (min-width: 768px) {
                    margin-top: 60px;
                }

                img {

                    height: 100%;
                    width: 100%;
                    object-fit: contain;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

            }
        }
    }
</style>